import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=5038a9f1&scoped=true&"
import script from "./orderList.vue?vue&type=script&lang=js&"
export * from "./orderList.vue?vue&type=script&lang=js&"
import style0 from "./orderList.vue?vue&type=style&index=0&id=5038a9f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5038a9f1",
  null
  
)

export default component.exports